import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const VariantSettingsThemeTicker = (props) => {
  const [contextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Tickers" open={false}>
        <VariantBuilderSetting
          object={variant}
          label="Background Color"
          setting_name="[options][ticker-background-color]"
          setting_type="color_v2"
          object_type="variants"
          value={variant.options["ticker-background-color"] || undefined}
          placeholder="transparent"
          show_reset={true}
          gradient={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Style"
          setting_name="[options][ticker-border-style]"
          setting_type="border_style"
          object_type="variants"
          value={variant.options["ticker-border-style"] || "none"}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Color"
          setting_name="[options][ticker-border-color]"
          setting_type="color_v2"
          object_type="variants"
          value={variant.options["ticker-border-color"] || undefined}
          placeholder="#000"
          condition={
            variant.options["ticker-border-style"] &&
            variant.options["ticker-border-style"] !== "none"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Border Width"
          setting_name="[options][ticker-border-width]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-border-width"] || undefined}
          placeholder="1"
          min={0}
          max={20}
          range_step={"1"}
          condition={
            variant.options["ticker-border-style"] &&
            variant.options["ticker-border-style"] !== "none"
          }
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Corner Radius"
          setting_name="[options][ticker-border-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="variants"
          value={variant.options["ticker-border-radius"] || "cf-not-rounded"}
          show_reset={true}
        />

        {variant.options["ticker-border-radius"] === "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][ticker-border-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={variant}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="variants"
                    value={
                      variant.options[`ticker-border-radius-${side}`] != null
                        ? variant.options[`ticker-border-radius-${side}`]
                        : "0"
                    }
                    min={0}
                    note={
                      side
                        .split("-")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" ")
                    }
                    col="3"
                    placeholder={"0px"}
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={variant}
          label="Scroll Speed (px/s)"
          setting_name="[options][ticker-speed]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-speed"] || undefined}
          placeholder="50"
          min={1}
          max={500}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={variant}
          label="Gap Between Images"
          setting_name="[options][ticker-image-gap]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-image-gap"] || undefined}
          placeholder="20"
          min={0}
          max={200}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={variant}
          label="Gap Between Images"
          setting_name="[options][ticker-image-gap-mobile]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-image-gap-mobile"] || undefined}
          placeholder={variant.options["ticker-image-gap"] || "20"}
          min={0}
          max={200}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={variant}
          label="Max Image Height"
          setting_name="[options][ticker-max-image-height]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-max-image-height"] || undefined}
          placeholder="120"
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={variant}
          label="Max Image Height"
          setting_name="[options][ticker-max-image-height-mobile]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-max-image-height-mobile"] || undefined}
          placeholder={variant.options["ticker-max-image-height"] || "120"}
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={variant}
          label="Max Image Width"
          setting_name="[options][ticker-max-image-width]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-max-image-width"] || undefined}
          placeholder="300"
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={variant}
          label="Max Image Width"
          setting_name="[options][ticker-max-image-width-mobile]"
          setting_type="range"
          object_type="variants"
          value={variant.options["ticker-max-image-width-mobile"] || undefined}
          placeholder={variant.options["ticker-max-image-width"] || "300"}
          min={0}
          max={1000}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default VariantSettingsThemeTicker;
